import { useState } from "react";
import MenuSectionHeader from "../menu/MenuSectionHeader";
import MenuPdfDropdown from "../menu/MenuPdfDropdown";
import MenuTypeSwitch from "../menu/MenuTypeSwitch";
import MenuItemDetailModal from "../menu/MenuItemDetailModal";
import FoodMenuBoard from "../menu/foods/FoodMenuBoard";
import DrinksMenuBoard from "../menu/drinks/DrinksMenuBoard";
import DrinksMenuAlcoholBoard from "../menu/drinks/DrinksMenuAlcoholBoard";
import LunchOfferBanner from "../menu/LunchOfferBanner";
import { logoWatermarkItems } from "../../data/logoWatermark";

function MenuSection({ t, lang, instagramUrl, facebookUrl }) {
  const [menuGroup, setMenuGroup] = useState("food");
  const [detailItem, setDetailItem] = useState(null);
  const isDrinks = menuGroup === "drink";

  return (
    <section
      className="landing-section menu-premium"
      id="etlap"
      data-nav-section="menu"
    >
      <div className="menu-logo-scatter" aria-hidden="true">
        {logoWatermarkItems.map((item, index) => (
          <img
            key={index}
            src="/img/mizulogo.png"
            alt=""
            className="menu-logo-scatter-item"
            style={{
              top: item.top,
              left: item.left,
              width: `${item.size}px`,
              transform: `translate(-50%, -50%) rotate(${item.rotate}deg)`,
            }}
          />
        ))}
      </div>

      <div className="container menu-premium-inner">
        <MenuSectionHeader t={t} menuGroup={menuGroup} />

        <div className="menu-top-bar">
          <div className="menu-top-bar-spacer" aria-hidden="true" />
          <MenuTypeSwitch
            value={menuGroup}
            onChange={setMenuGroup}
            label={t.typeLabel}
            foodsLabel={t.pdf.foods}
            drinksLabel={t.pdf.drinks}
          />
          <div className="menu-top-bar-side">
            <MenuPdfDropdown t={t} />
          </div>
        </div>

        <div className="menu-printed-boards">
          <div key={menuGroup} className="menu-printed-boards-pane">
            {isDrinks ? (
              <>
                <DrinksMenuBoard
                  lang={lang}
                  onOpen={setDetailItem}
                  vatNote={t.vatNote}
                />
                <DrinksMenuAlcoholBoard lang={lang} onOpen={setDetailItem} />
              </>
            ) : (
              <FoodMenuBoard
                lang={lang}
                onOpen={setDetailItem}
                vatNote={t.vatNote}
              />
            )}
          </div>
        </div>

        <LunchOfferBanner
          t={t.lunch}
          instagramUrl={instagramUrl}
          facebookUrl={facebookUrl}
        />
      </div>

      <MenuItemDetailModal
        item={detailItem}
        lang={lang}
        t={t}
        onClose={() => setDetailItem(null)}
      />
    </section>
  );
}

export default MenuSection;
